<template>
    <div>
        <div class="row">
            <div class="col-lg-6 offset-lg-3 col-12 text-center p-0">
                <div class="card shadow-sm">
                    <div class="card-header">
                        <p class="text-center" style="margin: 0px;">ผู้ค้ำประกัน</p>
                    </div>
                    <div class="card-body">
                        <p class="h6">กรุณายืนยันตัวตนผู้กู้และผู้คำประกัน เพื่อทำการยื่นขอสินเชื่อเงินสดผ่าน App</p>
                    </div>
                    <div class="card-body text-left">2. โปรดถือบัตรประจำตัวประชาชนและถ่ายรูปคู่กับบัตรประชาชน</div>
                    <div>
                        <picture-input
                            ref="pictureInput"
                            width="400"
                            height="400"
                            accept="image/jpeg,image/png,image/gif,image/svg,image/webp"
                            size="5"
                            :removable="true"
                            :customStrings="{
                                upload: '<p>อัพโหลดเรียบร้อย</p>',
                                drag: 'อัพโหลดรูป',
                                tap: 'อัพโหลดรูป',
                                change: 'เปลี่ยนรูป',
                                remove: 'ลบรูป',
                            }"
                            :zIndex="1000"
                            @change="onChange"
                            @remove="onRemove"
                        ></picture-input>
                    </div>

                    <hr>
                    <div class="row ma-1">
                        <div class="col-5">
                            <p>ถ่ายรูปคู่กับบัตรประชาชน</p>
                            <img src="/static/img/nimcap/IdCard2.png" class="img-fluid pa-2" alt="..">
                        </div>
                        <div class="col-7">
                            <ul>
                                <li class="list-text"> บัตรต้องไม่บังใบหน้าส่วนใดส่วนหนึ่ง</li>
                                <li class="list-text"> อย่าใส่หมวกหรือแว่นตาดำ</li>
                                <li class="list-text"> อย่าใส่ที่คาดผมหรือเครื่องประดับ</li>
                                <li class="list-text"> อย่าถ่ายแค่ครึ่งใบหน้า</li>
                                <li class="list-text"> รูปต้องชัดเจนให้ตัวอักษรบนบัตร</li>
                            </ul>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import { mapGetters, mapActions } from 'vuex'
import PictureInput from 'vue-picture-input'
export default {
  components: {
    PictureInput
  },
  computed: {
    ...mapGetters({
      nimcapDetils: 'nimcap/GET_DETAILS'
    })
  },
  methods: {
    ...mapActions({
      SET_EL_VALUE: 'nimcap/SET_EL_VALUE'
    }),
    onChange (image) {
      if (image) {
        let payload = {
          main_key: 'guarantorImage',
          sub_key: 'faceWithIdCardImage',
          value: image
        }
        this.SET_EL_VALUE(payload)
      } else {
        this.onRemove()
      }
    },
    onRemove () {
      let payload = {
        main_key: 'guarantorImage',
        sub_key: 'faceWithIdCardImage',
        value: null
      }
      this.SET_EL_VALUE(payload)
    }
  }
}
</script>
<style>
.list-text {
    list-style-type: '- ';
    text-align: left;
}
</style>


// WEBPACK FOOTER //
// src/components/nimcap/Components/Guarantor/Step5.vue